import { render, staticRenderFns } from "./adminStaffDetail.vue?vue&type=template&id=3dacb8ee&scoped=true"
import script from "./adminStaffDetail.vue?vue&type=script&lang=js"
export * from "./adminStaffDetail.vue?vue&type=script&lang=js"
import style0 from "./adminStaffDetail.vue?vue&type=style&index=0&id=3dacb8ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dacb8ee",
  null
  
)

export default component.exports